exports.components = {
  "component---src-pages-guias-js": () => import("./../../../src/pages/guias.js" /* webpackChunkName: "component---src-pages-guias-js" */),
  "component---src-templates-tag-js": () => import("./../../../src/templates/tag.js" /* webpackChunkName: "component---src-templates-tag-js" */)
}

